import './mobimax/controller';
import './mobimax/widget-car-filter';
//import './modules/product-filter';
import { carrambaProductFiltersClient } from './modules/carramba-product-filters-client';
import { shopDynamicSidebar } from './modules/shop-dynamic-sidebar';
import responsiveTable from "./modules/responsive-table";

window.addEventListener( 'DOMContentLoaded', function () {
    shopDynamicSidebar();
    carrambaProductFiltersClient();
    responsiveTable();
});
